import { Navigate, Route, Routes } from 'react-router-dom';
import { ProtectedRoute } from './auth/ProtectedRoute';
import { Layout } from './components/Layout';
import { Login } from './pages/Login';
import { ForgotPassword } from './pages/ForgotPassword';
import { ResetPassword } from './pages/ResetPassword';
import { AcceptInvite } from './pages/AcceptInvite';
import { Difot } from './pages/Difot';
import { FailedDeliveries } from './pages/FailedDeliveries';
import { DriverPerformance } from './pages/DriverPerformance';
import { CustomerFeedback } from './pages/CustomerFeedback';
import { DeliveryCost } from './pages/DeliveryCost';
import { InviteUser } from './pages/InviteUser';
import { NotFound } from './pages/NotFound';

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/accept-invite" element={<AcceptInvite />} />

      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<Navigate to="/difot" replace />} />
        <Route path="/dashboard" element={<Navigate to="/difot" replace />} />
        <Route path="/difot" element={<Difot />} />
        <Route path="/failed-deliveries" element={<FailedDeliveries />} />
        <Route path="/driver-performance" element={<DriverPerformance />} />
        <Route path="/customer-feedback" element={<CustomerFeedback />} />
        <Route path="/delivery-cost" element={<DeliveryCost />} />
        <Route path="/invite" element={<InviteUser />} />
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
